<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 max-w-6xl">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          ACREDITARME
        </h1>
        <h1 class="text-gray-800 mb-4 text-2xl text-center pt-2 pb-5">
          Por favor complete el formulario en su totalidad
        </h1>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric" @blur="validarDni" placeholder="Documento / Pasaporte"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text"  placeholder="Nombre" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text"  placeholder="Apellido"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text"  placeholder="Empresa"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text"  placeholder="Cargo"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Calle</label>
            <Field name="calle" v-slot="{ field, errors }" v-model="formData.calle">
              <InputText v-bind="field" type="text"  placeholder="Calle"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="calle" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Número</label>
            <Field name="numero" v-slot="{ field, errors }" v-model="formData.numero">
              <InputText v-bind="field" type="text"  placeholder="Número" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numero" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Piso</label>
            <Field name="piso" v-slot="{ field, errors }" v-model="formData.piso">
              <InputText v-bind="field" type="text"  placeholder="Piso"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="piso" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Departamento</label>
            <Field name="departamento" v-slot="{ field, errors }" v-model="formData.departamento">
              <InputText v-bind="field" type="text"  placeholder="Departamento"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="departamento" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código postal</label>
            <Field name="codigoPostal" v-slot="{ field, errors }" v-model="formData.codigoPostal">
              <InputText v-bind="field" type="text"  placeholder="Código postal"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoPostal" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">País (Domicilio)</label>
            <Field name="paisDomicilio" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.paisDomicilio">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="País" class="input-base" :options="paises" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="paisDomicilio" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.id != '+54'">
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su provincia o estado"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provinciaEstado" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.id == '+54'">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.localidad">
                <Select @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la localidad" class="input-base" :options="localidades" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.id != '+54'">
            <label class="block mb-1">Localidad / Ciudad</label>
            <Field name="localidadCiudad" v-slot="{ field, errors }" v-model="formData.localidadCiudad">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su localidad o ciudad"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidadCiudad" /></span>
            </Field>
          </div>

        </div>

        <!-- Telefono fijo -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">País (Teléfono fijo)</label>
              <Select v-model="selectedCountryFijo" filter :options="paises" optionLabel="descripcion" placeholder="Seleccione un país" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountryFijo !== null" v-model="selectedCountryFijo.id" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoAreaFijo" v-slot="{ field, errors }" v-model="formData.codigoAreaFijo">
              <InputText v-bind="field" type="text"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoAreaFijo" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono fijo</label>
            <Field name="telefonoFijo" v-slot="{ field, errors }" v-model="formData.telefonoFijo">
              <InputText v-bind="field" type="text"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoFijo" /></span>
            </Field>
          </div>
        </div>

        <!-- Telefono fijo -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">País (Teléfono celular)</label>
              <Select v-model="selectedCountryCel" filter :options="paises" optionLabel="descripcion" placeholder="Seleccione un país" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountryCel !== null" v-model="selectedCountryCel.id" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoAreaCel" v-slot="{ field, errors }" v-model="formData.codigoAreaCel">
              <InputText v-bind="field" type="text"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoAreaCel" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text"  placeholder="Mail"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Web Site</label>
            <Field name="webSite" v-slot="{ field, errors }" v-model="formData.webSite">
              <InputText v-bind="field" type="text"  placeholder="Web site"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="webSite" /></span>
            </Field>
          </div>
        </div>

        <!-- Combos -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Profesión / Actividad</label>
            <Field name="profesion" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.profesion">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione su profesión" class="input-base" :options="profesiones" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="profesion" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Otra profesión</label>
            <Field name="profesionOtra" v-slot="{ field, errors }" v-model="formData.profesionOtra">
              <InputText v-bind="field" :readonly="formData.profesion?.id !== 'Otro'" type="text"  placeholder="Otra profesión"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="profesionOtra" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Rubro de su empresa</label>
            <Field name="rubro" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubro">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el rubro" class="input-base" :options="rubros" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubro" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">Otro rubro</label>
            <Field name="rubroOtro" v-slot="{ field, errors }" v-model="formData.rubroOtro">
              <InputText v-bind="field" :readonly="formData.rubro?.id !== 'Otro'" type="text"  placeholder="Otro rubro"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubroOtro" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">¿Cómo se enteró?</label>
            <Field name="medio" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.medio">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el medio" class="input-base" :options="medios" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="medio" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Otro medio</label>
            <Field name="medioOtro" v-slot="{ field, errors }" v-model="formData.medioOtro">
              <InputText v-bind="field" :readonly="formData.medio?.id !== 'Otro'" type="text"  placeholder="Otro medio"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="medioOtro" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Rol en la compra</label>
            <Field name="rolCompra" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rolCompra">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione su rol" class="input-base" :options="rolesCompra" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rolCompra" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Seleccione su rango etario</label>
            <Field name="rangoEtario" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rangoEtario">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el rango etario" class="input-base" :options="rangosEtarios" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rangoEtario" /></span>
            </Field>
          </div>
        </div>
          
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Seleccione el objetivo de su visita</label>
            <Field name="objetivos" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.objetivos">
                <MultiSelect @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione los objetivo de su visita" class="input-base" :options="objetivos" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="objetivos" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Seleccione sus rubros de interés</label>
            <Field name="rubrosInteres" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubrosInteres">
              <MultiSelect @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione los canales de interés" class="input-base" :options="rubrosInteresList" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubrosInteres" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>

    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" fullScreen />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import HeaderSection from './HeaderSection.vue';
import FullScreenLoader from '@/components/FullScreenLoader.vue';

import jsonCountries from '@/data/countries.json';
import jsonMedios from '@/data/medios.json';
import jsonObjetivos from '@/data/objetivos.json';
import jsonProfesiones from '@/data/profesiones.json';
import jsonRolesCompra from '@/data/rolesCompra.json';
import jsonRubros from '@/data/rubros.json';
import jsonRubrosInteres from '@/data/rubrosInteres.json';
import jsonRagosEtarios from '@/data/rangosEtarios.json';

import jsonProvincias from '@/data/provincias.json';
import jsonLocalidades from '@/data/localidades.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity, StringIdLabelEntity, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Pais  extends StringIdLabelEntity {}
interface Medio extends StringIdLabelEntity {}
interface Objetivo extends StringIdLabelEntity {}
interface Profesion extends StringIdLabelEntity {}
interface Rubro extends StringIdLabelEntity {}
interface RolCompra extends StringIdLabelEntity {}
interface RubroInteres extends StringIdLabelEntity {}
interface RangoEtario extends StringIdLabelEntity {}
interface Provincia extends IdLabelEntity {}
interface Localidad extends IdLabelEntity {}

export default defineComponent({
  components: {
    HeaderSection,
    InputText, Select, MultiSelect,
    Field, ErrorMessage, Form, FullScreenLoader
  },
  created () {
    document.title = "BATEV 2026 - Acreditación";
  },
  data() {
    return {
      paises: [] as Pais[],
      provincias: [] as Provincia[],
      localidades: [] as Localidad[],
      profesiones: [] as Profesion[],
      rubros: [] as Rubro[],
      medios: [] as Medio[],
      rolesCompra : [] as RolCompra[],
      objetivos: [] as Objetivo[],
      rubrosInteresList: [] as RubroInteres[],
      rangosEtarios: [] as RangoEtario[],
      selectedCountryCel: {"id": "+54", "descripcion": "Argentina"} as Pais,
      selectedCountryFijo: {"id": "+54", "descripcion": "Argentina"} as Pais,
      isSubmitting: false,
      formData: {
        nombre: '',
        apellido: '',
        documento: '',
        empresa: '',
        cargo: '',
        calle: '',
        numero: '',
        piso: '',
        departamento: '',
        codigoPostal: '',
        paisDomicilio: {"id": "+54", "descripcion": "Argentina"} as Pais,
        localidad: undefined as unknown as Localidad,
        localidadCiudad: '',
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        codigoAreaCel: '',
        codigoAreaFijo: '',
        telefonoCelular: '',
        telefonoFijo: '',
        mail:  '',
        webSite: '',
        profesion: undefined as unknown as Profesion,
        profesionOtra: '',
        rubro: undefined as unknown as Rubro,
        rubroOtro: '',
        medio: undefined as unknown as Medio,
        medioOtro: '',
        rolCompra: undefined as unknown as RolCompra,
        rubrosInteres: undefined as unknown as RubroInteres[],
        objetivos: undefined as unknown as Objetivo[],
        rangoEtario: undefined as unknown as RangoEtario,
        origenEnlace: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(3, 'Al menos 3 letras'),
        documento: yup.string().required('Ingrese su documento').min(6, 'Al menos 6 números'),
        empresa: yup.string().required('Ingrese su empresa').min(3, 'Al menos 3 letras'),
        cargo: yup.string().required('Ingrese su cargo').min(3, 'Al menos 3 letras'),
        calle: yup.string().required('Ingrese la calle').min(3, 'Al menos 3 letras'),
        numero: yup.string().required('Ingrese el número').matches(/^\d+$/, 'Solo se permiten números'),
        codigoPostal: yup.string().required('Ingrese el código postal').min(3, 'Al menos 3 letras'),
        codigoAreaFijo: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoFijo: yup.string().required('Ingrese el teléfono fijo').matches(/^\d+$/, 'Solo se permiten números'),
        codigoAreaCel: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        mail: yup.string().required('Ingrese su correo').email('Correo inválido'),
        webSite: yup.string().required('Ingrese su web'),
        
        provincia: yup.mixed().test('validacion-provincia-argentina', 'Seleccione la provincia', function(value) {
          const paisSelected = this.parent.paisDomicilio;     
          if(paisSelected?.id == '+54' && !value) {
              return false;
          }
          return true;
        }),

        localidad: yup.mixed().test('validacion-localidad-argentina', 'Seleccione la localidad', function(value) {
          const paisSelected = this.parent.paisDomicilio;
          if(paisSelected?.id == '+54' && !value) {
              return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-otro', 'Ingrese la provincia/estado', function(value) {
          const paisSelected = this.parent.paisDomicilio;     
          if(paisSelected?.id != '+54' && !value) {
              return false;
          }
          return true;
        }),

        localidadCiudad: yup.string().test('validacion-localidad-otro', 'Ingrese la localidad/ciudad', function(value) {
          const paisSelected = this.parent.paisDomicilio;
          if(paisSelected?.id != '+54' && !value) {
              return false;
          }
          return true;
        }),


        profesion: yup.mixed().required('Seleccione su profesión'),
        profesionOtra: yup.string().test('validacion-profesion', 'Especifique cual', function(value) {
          const profesionSelected = this.parent.profesion;
          if(profesionSelected?.id === 'Otro' && !value) {
              return false;
          }
          return true;
        }),

        rubro: yup.mixed().required('Seleccione el rubro'),
        rubroOtro: yup.string().test('validacion-rubro', 'Especifique cual', function(value) {
          const rubroSelected = this.parent.rubro;
          if(rubroSelected?.id === 'Otro' && !value) {
              return false;
          }
          return true;
        }),

        medio: yup.mixed().required('Seleccione el medio'),
        medioOtro: yup.string().test('validacion-medio', 'Especifique cual', function(value) {
          const medioSelected = this.parent.medio;
          if(medioSelected?.id === 'Otro' && !value) {
              return false;
          }
          return true;
        }),
        
        rolCompra : yup.mixed().required('Seleccione su rol en la compra'),
        objetivos : yup.mixed().required('Seleccione el objetivo de su visita'),
        rubrosInteres : yup.mixed().required('Seleccione sus rubros de interés'),
        rangoEtario : yup.mixed().required('Seleccione su rango etario'),

      });
    }
  },
  watch: {
    'formData.profesion.id'(newValue) {
      if (newValue !== 'Otro') {
        this.formData.profesionOtra = '';
      }
    },
    'formData.rubro.id'(newValue) {
      if (newValue !== 'Otro') {
        this.formData.rubroOtro = '';
      }
    },
    'formData.medio.id'(newValue) {
      if (newValue !== 'Otro') {
        this.formData.medioOtro = '';
      }
    },
    'formData.provincia.id'(newValue) {
      if (newValue) {
        this.localidades = jsonLocalidades;
        this.localidades = this.localidades.filter((localidad: Localidad) => localidad.id === newValue);
      }
    },
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + " error/es)", icon: "error"});
    },
    async validarDni() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
        if (acreditadoExistente) {
          this.isSubmitting = false;
          Swal.fire({ 
              title: "Atención", 
              html: "El DNI / Pasaporte ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.",
              icon: "warning" }).then(() => {
                window.location.href = "https://www.batev.com.ar";
          });
          return;
        }
      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        this.isSubmitting = false;
        Swal.fire({ 
            title: "Atención", 
            html: "El DNI / Pasaporte ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "warning" }).then(() => {
              window.location.href = "https://www.batev.com.ar";
        });
        return;
      }

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 2303 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.dni = this.formData.documento;
      acreditado.empresa = this.formData.empresa;
      acreditado.cargo = this.formData.cargo;
      acreditado.mail = this.formData.mail;
      
      acreditado.telefono = this.selectedCountryCel.id + this.formData.codigoAreaCel + this.formData.telefonoCelular;
      acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      acreditado.notificarWhatsApp = false;
      
      acreditado.dato14 = this.formData.paisDomicilio?.descripcion;

      if(this.formData.paisDomicilio?.id == "+54") {
        acreditado.dato1 = this.formData.provincia?.descripcion;
        acreditado.dato5 = this.formData.localidad?.descripcion;
      } else {
        acreditado.dato1 = this.formData.provinciaEstado;
        acreditado.dato5 = this.formData.localidadCiudad;
      }

      acreditado.dato3 = this.formData.webSite;
      acreditado.dato25 = this.formData.codigoPostal;
      acreditado.dato6 = this.formData.calle;
      acreditado.dato22 = this.formData.numero;
      acreditado.dato23 = this.formData.piso;
      acreditado.dato24 = this.formData.departamento;

      acreditado.dato7 = this.formData.profesion?.id;
      acreditado.dato9 = this.formData.rubro?.id;
      acreditado.dato11 = this.formData.medio?.id;

      acreditado.dato18 = this.formData.profesion?.id == 'Otro'? this.formData.profesionOtra : "";
      acreditado.dato19 = this.formData.rubro?.id == 'Otro'? this.formData.rubroOtro : "";
      acreditado.dato20 = this.formData.medio?.id == 'Otro'? this.formData.medioOtro: "";

      acreditado.dato8 = this.formData.rolCompra?.id;
      acreditado.dato10 = this.formData.objetivos.map(rubro => rubro.descripcion).join(', ');
      acreditado.dato15 = this.formData.rubrosInteres.map(rubro => rubro.descripcion).join(', ');
      acreditado.dato12 = this.selectedCountryFijo?.id;
      acreditado.dato13 = this.formData.codigoAreaFijo;
      acreditado.dato2 = this.formData.telefonoFijo;
      acreditado.dato16 = this.formData.rangoEtario?.id;

      acreditado.dato4 = this.formData.origenEnlace;

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
        
        Swal.fire({
            title: "Acreditación exitosa",
            html: "Estimado/a:<br>Hemos recibido sus datos de registración con éxito.<br/><br/>Le enviamos un mail con un enlace para descargar su credencial para concurrir al evento.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "success",
        }).then(() => {
          window.location.href = "https://www.batev.com.ar";
        });

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.paises = jsonCountries;
    this.profesiones = jsonProfesiones;
    this.rubros = jsonRubros;
    this.medios = jsonMedios;
    this.rolesCompra = jsonRolesCompra;
    this.objetivos = jsonObjetivos;
    this.rubrosInteresList = jsonRubrosInteres;
    this.rangosEtarios = jsonRagosEtarios;
    this.provincias = jsonProvincias;

    const paramOrigen = this.$route.params.origenEnlace as string;
    if (paramOrigen) {
      this.formData.origenEnlace = paramOrigen;
    } else {
      this.formData.origenEnlace = "WEB";
    }

  }
});
</script>
